export interface IPatientFormQuestionnaire {
  SiteID: number;
  ID: number;
  Form: IForm;
  Responses: Array<IResponses>;
  ServerTime: Date;
  PatientFormQuestionnaireStatus: string;
  Type: any;
  SiteAssetStatusComments: Array<any>;
  StatusModel: IStatusModel;
}

export interface IForm {
  FormID: number;
  FormName: string;
  FormCreatedByUserID: number;
  HasSignature: boolean;
  IntroText: string;
  FinishText: string;
  HasAnswers: boolean;
  TestID: any;
  mid: string;
  Disabled: boolean;
  Preview: boolean;
  DisplayOrdinals: boolean;
  SiteAssetID: number;
  SiteID: number;
  SiteAssetStatusTypeID: number;
  Questions: Array<IQuestions>;
}

export interface IResponses {
  _FormResponseID: number;
  FormQuestionID: number;
  TestID: any;
  ResponseEnumerator: number;
  UserID: number;
  ResponseChar: string;
  ResponseInt: any;
  FormAnswerIDs: string;
  AuditInfoID: number;
  AuditInfo: any;
  FormQuestion: string;
  ConnectionString: string;
}
export interface IStatusModel {
  StatusType: any;
  SelectedValue: any;
}

export interface IQuestions {
  QuestionID: number;
  QuestionText: string;
  QuestionTextStyle: string;
  QuestionSubText: string;
  QuestionSubTextStyle: string,
  DefaultValue: any;
  MergeFieldID: number;
  MergeFieldName: string;
  QuestionTypeID: number;
  QuestionType: string;
  QuestionOrdinal: number;
  QuestionRenderID: number;
  QuestionRender: string;
  IsRequired?: boolean;
  IsLogDisplay?: boolean;
  IsFlagged?: boolean;
  QuestionGroupID: number;
  QuestionGroupName: string;
  QuestionGroupNameStyle: string;
  QuestionGroupTypeID: number;
  QuestionGroupTypeName: string;
  IsGroupNameRendered?: boolean;
  QuestionGroupOrdinal: number;
  IsGroupLinked?: boolean;
  IsQuestionLinked?: boolean;
  IsLinkedGroupDisabled?: boolean;
  IsLinkedGroupRendered?: boolean;
  IsLinked?: boolean,
  LinkedQuestion: any;
  LinkedQuestionID: number;
  LinkedQuestionMasterID: number;
  LinkedGroupMasterID: number;
  IsLinkedRendered?: boolean;
  IsLinkedDisabled?: boolean;
  HasQuestionDef?: boolean;
  ParameterMale: any;
  ParameterMale1: any;
  ParameterFemale: any;
  ParameterFemale1: any;
  LinkedQuestionMasterID1: number;
  Answers: Array<IAnswers>;
  MatrixQuestion: any;

  uniquename: string;
  controlDisabled: boolean;
  controlVisibled: boolean;
  parentVisibleApplied: boolean;
  parentQuestionIds: number[];
  isArray: boolean;
  response?: IResponses;
}

export interface IAnswers {
  FormAnswerID: number;
  FormQuestionID: number;
  Answer: string;
  IsFilter: boolean;
  LinkedId: number;
  IsGroupLink: boolean;
  IsCorrect: boolean;
  IsExtended: boolean;
  ExtendedPrompt: any;
  AnswerOrdinal: number;
  AnswerMapping: any;
  IsActive: number;
  dateToExpire: Date;
  AuditInfoID: number;
  AuditInfo: any;
  FormQuestion: any;

  checked: boolean;
  uniquename: string;
}

///=====================================================///

export interface IForms {
  AssetID:number;
  FormID: number;
  FormName: string;
  CategoryName: string;
  DateCreated: Date;
  DateDue: Date;
  Status: string;
}

export enum FormLogType {
  SiteLog = 1,
  AdminLog = 2,
  StudyTeamLog = 3,
  MyLog = 4,
}

export enum Form {
  Site = 2,
  User = 3,  
}


export interface IGridLogFetchOption {
  Sort: any[];
  Page: number;
  PageSize: number,
  SiteID: number;
  RoleID: number,
  CountryID: number,
  StatusID: number,
  DateofSubmission?: string,
  DateCreated?: string,
  FormID: number,
  LogFeatureType: string,
  FormTestID:number,
  UserId:number,
  InvestigatorName:string
}

export interface ISaveAnswer {
  TestId: any;
  QuestionId: number;
  AnswerId: string;
  Answer: string;
}

export interface ISubmitForm {
  Comment: string;
  InvestigatorName: string;
  SiteFormStatusTypeId: string;
  SubjectScreeningNumber: string;
}

export enum siteFormStatus {
  PendingSubmission = 10,
  Submitted = 11,
  MeetsCriteria = 12,
  InformationNeeded = 13,
  DoesNotMeetCriteria = 14,
  InformationProvided = 15
}
export enum userFormStatus {
  PendingSubmission = 16,
  Submitted = 17,
  Accepted = 18,
  Declined = 19,
  ClarificationInformationNeeded = 20,
  InformationProvided = 21
}
